import $ from "jquery";

const MobileMenu = (el) => {
    const $el = $(el);
    $el.on("click", function (e) {
        e.preventDefault();

        $("body").toggleClass("js-state-menu-open");
        $el.toggleClass("js-state-menu-open");

        if ($el.data("toggle") !== undefined) {
            $($el.data("toggle")).toggleClass("js-state-menu-open");
        }
    });
    // Function to handle scroll event
    function handleScroll() {
        if ($(window).scrollTop() > 0) {
            // Page has been scrolled down
            $("body").addClass("js-state-scrolled-down");
        } else {
            // Page is at the top
            $("body").removeClass("js-state-scrolled-down");
        }
    }

    // Attach scroll event listener
    $(window).on("scroll", handleScroll);

    // Initial check
    handleScroll();

    $(document).on('keyup', function (e) {
        if (e.key === "Escape") {
            $("body").removeClass("js-state-menu-open");
            $el.removeClass("js-state-menu-open");
        }
    });
};

export default MobileMenu;
